import React from "react";
import styles from "../styles/platos.module.css";
import ScrollMultiSelect from "./ScrollMultiSelect";

export default function PlatoModal({
    open,
    editing,
    formData,
    setFormData,
    alergenos,
    onClose,
    onSubmit,
}) {
    if (!open) return null;

    return (
        <div className={styles["modal-overlay"]}>
            <div className={`${styles["modal-content"]} ${styles["modal-form"]}`}>
                <form onSubmit={onSubmit}>
                    <h3>{editing ? "Editar plato" : "Nuevo plato"}</h3>

                    <div className={styles["grid-2"]}>
                        <div className={styles.field}>
                            <div className={styles.field}>
                                <label className={styles.label}>Nombre</label>
                                <input
                                    type="text"
                                    name="nombre"
                                    value={formData.nombre}
                                    onChange={(e) => setFormData((p) => ({ ...p, nombre: e.target.value }))}
                                    placeholder="Nombre del plato"
                                    required
                                />
                            </div>

                            <div className={styles.field}>
                                <label className={styles.label}>Descripción</label>
                                <textarea
                                    name="descripcion"
                                    value={formData.descripcion}
                                    onChange={(e) => setFormData((p) => ({ ...p, descripcion: e.target.value }))}
                                    placeholder="Escribe una breve descripción"
                                />
                            </div>
                        </div>

                        <div className={styles.field}>
                            <label className={styles.label}>Alérgenos</label>
                            <ScrollMultiSelect
                                options={(alergenos || []).map((a) => ({
                                    value: a.id,
                                    label: a.alergenoDescripcion || a.alergeno,
                                }))}
                                value={formData.alergenosIds}
                                onChange={(vals) => setFormData((prev) => ({ ...prev, alergenosIds: vals }))}
                                placeholder="Buscar alérgeno…"
                                height={180}
                            />
                        </div>
                    </div>

                    <details className={styles.card} style={{ marginTop: 12 }}>
                        <summary style={{ cursor: "pointer" }}>Traducción (Inglés)</summary>
                        <div className={styles["grid-2"]} style={{ marginTop: 12 }}>
                            <div className={styles.field}>
                                <label className={styles.label}>Name (EN)</label>
                                <input
                                    type="text"
                                    name="nombre_en"
                                    value={formData.nombre_en}
                                    onChange={(e) => setFormData((p) => ({ ...p, nombre_en: e.target.value }))}
                                    placeholder="Dish name in English"
                                />
                            </div>
                            <div className={styles.field}>
                                <label className={styles.label}>Description (EN)</label>
                                <textarea
                                    name="descripcion_en"
                                    value={formData.descripcion_en}
                                    onChange={(e) => setFormData((p) => ({ ...p, descripcion_en: e.target.value }))}
                                    placeholder="Short description in English"
                                />
                            </div>
                        </div>
                    </details>

                    <div className={styles["modal-actions"]}>
                        <button type="button" className={`${styles.btn} ${styles.ghost}`} onClick={onClose}>
                            Cancelar
                        </button>
                        <button type="submit" className={`${styles.btn} ${styles.primary}`}>
                            Guardar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
